const featuredPressRelease = {
  displayField: 'header',
  name: 'Featured Press Release',
  description: 'Featured Press Release schema template',
  fields: [
    {
      id: 'img',
      name: 'Image',
      type: 'Link',
      localized: false,
      required: false,
      validations: [],
      disabled: false,
      omitted: false,
      linkType: 'Asset'
    },
    {
      id: 'header',
      name: 'Header',
      type: 'Symbol',
      localized: true,
      required: false,
      validations: [],
      disabled: false,
      omitted: false
    },
    {
      id: 'bodyText',
      name: 'Body Text',
      type: 'Text',
      localized: true,
      required: false,
      validations: [],
      disabled: false,
      omitted: false
    },
    {
      id: 'ctaText',
      name: 'Button Text',
      type: 'Symbol',
      localized: true,
      required: false,
      validations: [],
      disabled: false,
      omitted: false
    },
    {
      id: 'ctaUrl',
      name: 'Button Url',
      type: 'Symbol',
      localized: false,
      required: false,
      validations: [],
      disabled: false,
      omitted: false
    }
  ],
  sys: {
    id: 'featuredPressRelease',
    version: 6,
    updatedAt: '2023-08-11T15:49:55.066Z'
  }
};
export default featuredPressRelease;